import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getProductosDesayuno,
  getCategoriasProductosDesayuno,
  updateProductDesayuno,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_PRODUCTOS_DESAYUNO(action) {
  try {
    const dataProductosDesayuno = yield call(getProductosDesayuno, action.payload)
    if (dataProductosDesayuno.ok) {
      yield put({
        type: actions.PRODUCTOS_DESAYUNO_LOAD_SUCCEEDED,
        payload: dataProductosDesayuno.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los productos desayuno')
      put({
        type: actions.PRODUCTOS_DESAYUNO_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PRODUCTOS_DESAYUNO_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_CATEGORIAS_PRODUCTOS_DESAYUNO(action) {
  try {
    const dataProductosDesayuno = yield call(getCategoriasProductosDesayuno, action.payload)
    if (dataProductosDesayuno.ok) {
      yield put({
        type: actions.PRODUCTOS_DESAYUNO_CATEGORIAS_SUCCEEDED,
        payload: dataProductosDesayuno.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar las categorias de los productos desayuno')
      put({
        type: actions.PRODUCTOS_DESAYUNO_CATEGORIAS_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PRODUCTOS_DESAYUNO_CATEGORIAS_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_PRODUCTO_DESAYUNO(action) {
  try {
    const productoObj = yield call(updateProductDesayuno, action.payload)
    if (productoObj.ok) {
      putMessage(messageType.SUCCESS, 'Producto desayuno modificado correctamente')
      yield put({
        type: actions.PRODUCTOS_DESAYUNO_UPDATE_SUCCEEDED,
        payload: productoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar producto desayuno')
      yield put({
        type: actions.PRODUCTOS_DESAYUNO_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificadar producto desayuno')
    yield all([
      put({
        type: actions.PRODUCTOS_DESAYUNO_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.PRODUCTOS_DESAYUNO_LOAD_REQUESTED, GET_PRODUCTOS_DESAYUNO),
    takeEvery(actions.PRODUCTOS_DESAYUNO_CATEGORIAS_REQUESTED, GET_CATEGORIAS_PRODUCTOS_DESAYUNO),
    takeEvery(actions.PRODUCTOS_DESAYUNO_UPDATE_REQUESTED, UPDATE_PRODUCTO_DESAYUNO),
  ])
}
